"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var extension_image_1 = require("@tiptap/extension-image");
var core_1 = require("@tiptap/core");
exports.default = extension_image_1.default.extend({
    name: 'custom-image',
    addAttributes: function () {
        return __assign(__assign({}, extension_image_1.default.config.addAttributes()), { class: {
                default: 'image',
                rendered: false,
            } });
    },
    addCommands: function () {
        var _this = this;
        return {
            setImage: function (options) { return function (_a) {
                var _b, _c, _d;
                var tr = _a.tr, commands = _a.commands;
                if (((_d = (_c = (_b = tr.selection) === null || _b === void 0 ? void 0 : _b.node) === null || _c === void 0 ? void 0 : _c.type) === null || _d === void 0 ? void 0 : _d.name) == 'custom-image') {
                    return commands.updateAttributes('custom-image', options);
                }
                else {
                    return commands.insertContent({
                        type: _this.name,
                        attrs: options
                    });
                }
            }; },
        };
    },
    renderHTML: function (_a) {
        var node = _a.node, HTMLAttributes = _a.HTMLAttributes;
        HTMLAttributes.class = 'custom-image-' + node.attrs.class;
        return [
            'img',
            core_1.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
        ];
    }
});
